import type { ComponentPropsWithoutRef } from "react";

/**
 * Lightweight GFM table override for the chat markdown renderer.
 *
 * Renders tables as plain styled `<table>` elements that feel text-native
 * inside the chat bubble. The outer wrapper constrains the table to the
 * bubble's width and scrolls horizontally when the content overflows,
 * keeping the rest of the chat layout stable.
 */
export function MarkdownTable({
  children,
  node: _node,
  ...rest
}: ComponentPropsWithoutRef<"table"> & { readonly node?: unknown }) {
  return (
    <div className="my-2 max-w-full overflow-x-auto">
      <table
        {...rest}
        className="w-full text-sm border-collapse [&_th]:text-left [&_th]:font-medium [&_th]:text-muted-foreground [&_th]:pb-1.5 [&_th]:pr-4 [&_th]:border-b [&_th]:border-border [&_td]:py-1 [&_td]:pr-4 [&_td]:border-b [&_td]:border-border/50 [&_tr:last-child_td]:border-b-0"
      >
        {children}
      </table>
    </div>
  );
}
